import AddCircleIcon from "@mui/icons-material/AddCircle";
import ViewAgendaIcon from "@mui/icons-material/ViewAgenda";
import TabContext from "@mui/lab/TabContext";
import TabList from "@mui/lab/TabList";
import TabPanel from "@mui/lab/TabPanel";
import {
  Autocomplete,
  Box,
  Chip,
  Divider,
  Grid,
  IconButton,
  Tooltip
} from "@mui/material";
import Paper from "@mui/material/Paper";
import Tab from "@mui/material/Tab";
import TextField from "@mui/material/TextField";
import Typography from "@mui/material/Typography";
import { styled } from "@mui/material/styles";
import React, { useContext, useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { api } from "../api";
import AuthContext from "../auth/AuthProvider";
import { fetchToken } from "../auth/Token";
import { DashSavings } from "../components/DashSavings";
import Header from "../components/Header";

const Item = styled(Paper)(({ theme }) => ({
  backgroundColor: theme.palette.mode === "dark" ? "#1A2027" : "#fff",
  ...theme.typography.body2,
  padding: theme.spacing(1),
  color: theme.palette.text.secondary,
}));


const Ittem = styled(Paper)(({ theme }) => ({
  backgroundColor: "#fff",
  ...theme.typography.body2,
  padding: theme.spacing(2),
  borderStyle: "groove",
  border: "3px",
  borderColor: "grey",
  boxShadow: "0 4px 12px rgba(0, 0, 0, 0.2), 0 6px 20px rgba(0, 0, 0, 0.2)",
  marginTop: "10px",
  minHeight: "50px",
  borderRadius: "10px",
}));

const SavingsAccountPage = () => {
  const [value, setValue] = React.useState("1");
  const location = useLocation();
  const other_accounts = location.state && location.state.accounts;
  const [account_id, setAccount_id] = useState(location.state && location.state.id)
  const [details, setDetails] = useState([]);
  const [accOpen, setAccOpen] = useState([]);
  const [societies, setSocieties] = useState([]);
  const [society_id, setSociety_id] = useState();
  const [unions, setUnions] = useState([]);
  const [apexes, setApexes] = useState([]);
  const [hold_name, setHold_name] = useState('');
  const { permissions } = useContext(AuthContext);
  const [society_dash, setSociety_dash] = useState(
    // <DashSavings
    //   account_id={account_id}
    //   society_id={20}
    //   name="Gushegu Society-Farmer Cooperative Mutual Support and Social Services Ltd."
    // />
  );

  const handleDisplaySociety = (society_id, society) => {
    setHold_name(society)
    setSociety_id(society_id);
    setSociety_dash(
      <DashSavings
        account_id={account_id}
        society_id={society_id}
        name={society}
        clo={true}
      />
    );
  };

  const account_switch = (id) => {
    setAccount_id(id)
    setSociety_dash(
      <DashSavings
        account_id={id}
        society_id={society_id}
        name={hold_name}
        clo={false}
      />
    );
  }
  

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  const fetch_things = () => {
    api
      .get("/association/societies/allshch", {
        headers: {
          Authorization: "Bearer " + fetchToken(),
        },
      })
      .then(function (response) {
        setSocieties(response.data?.Society);
      })
      .catch(function (error) {
        console.log(error);
      });

    api
      .get("/association/unions/allshch", {
        headers: {
          Authorization: "Bearer " + fetchToken(),
        },
      })
      .then(function (response) {
        setUnions(response.data?.Unions);
      })
      .catch(function (error) {
        console.log(error);
      });

    api
      .get("/association/apexes/allshch", {
        headers: {
          Authorization: "Bearer " + fetchToken(),
        },
      })
      .then(function (response) {
        setApexes(response.data?.Apexes);
      })
      .catch(function (error) {
        console.log(error);
      });
  };

  useEffect(() => {
    fetch_things();
  }, []);

  const fetchDetails = () => {
    api
      .get(`/account/one/savings/${account_id}`, {
        headers: {
          Authorization: "Bearer " + fetchToken(),
        },
      })
      .then(function (response) {
        setDetails(response.data?.Account_Details);
        setAccOpen(response.data?.Account_opened);
      })
      .catch(function (error) {
        console.log(error);
      });
  };

  useEffect(() => {
    fetchDetails();
  }, []);

  // console.log(accOpen)

  return (
    <div className="app">
      <main className="content">
        <Box sx={{ m: 4 }}>
          <Box
            display="flex"
            justifyContent="space-between"
            alignItems="center"
          >
            <Header
              title="Savings Account"
              subtitle={
                details.account_name &&
                typeof details.account_name == "string" &&
                details.account_name.includes("Accounts" || "accounts" || "Account" || "account")
                  ? details.account_name
                  : `${details.account_name} Account`
              }
            />
          </Box>
          <Grid container spacing={2}>
            <Grid item xs={12} md={12}>
              <TabContext value={value}>
                <TabList
                  onChange={handleChange}
                  sx={{
                    m: "auto",
                    display: "flex",
                    flexDirection: "row",
                    justifyContent: "center",
                    backgroundColor: "#ffffff",
                    borderWidth: 2,
                    borderRadius: 4,
                    p: 0,
                    maxWidth: "22%",
                    alignItems: "center",
                  }}
                  aria-label="lab API tabs example"
                >
                  <Tab
                    sx={{
                      pt: 0,
                      pb: 0,
                      pr: 1,
                      pl: 1,
                      backgroundColor: "#ffffff",
                      borderRadius: 4,
                      borderWidth: "2px",
                      boxShadow:
                        "0 4px 8px rgba(0, 0, 0, 0.1), 0 6px 20px rgba(0, 0, 0, 0.1)",
                      m: "8px",
                    }}
                    label={
                      <Typography
                        variant="subtitle"
                        fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif"
                      >
                        <b>Societies</b>
                      </Typography>
                    }
                    value="1"
                  />
                  <Tab
                    sx={{
                      pt: 0,
                      pb: 0,
                      pr: 1,
                      pl: 1,
                      backgroundColor: "#ffffff",
                      borderRadius: 4,
                      borderWidth: "2px",
                      boxShadow:
                        "0 4px 8px rgba(0, 0, 0, 0.1), 0 6px 20px rgba(0, 0, 0, 0.1)",
                      m: "8px",
                    }}
                    label={
                      <Typography
                        variant="subtitle"
                        fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif"
                      >
                        <b>Unions</b>
                      </Typography>
                    }
                    value="2"
                  />
                  <Tab
                    sx={{
                      pt: 0,
                      pb: 0,
                      pr: 1,
                      pl: 1,
                      backgroundColor: "#ffffff",
                      borderRadius: 4,
                      borderWidth: "2px",
                      boxShadow:
                        "0 4px 8px rgba(0, 0, 0, 0.1), 0 6px 20px rgba(0, 0, 0, 0.1)",
                      m: "8px",
                      mr: "5px",
                    }}
                    label={
                      <Typography
                        variant="subtitle"
                        fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif"
                      >
                        <b>Apex</b>
                      </Typography>
                    }
                    value="3"
                  />
                </TabList>

                <Grid container spacing={2}>
                  <Grid item xs={12} md={12}>
                    {/* Societies */}
                    <TabPanel value="1">
                      <Grid container spacing={2}>
                        <Grid item xs={12} md={6}>
                          <Ittem>
                            <Typography
                              fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif"
                            >
                              <b>Choose Society</b>
                            </Typography>

                            <Autocomplete
                              disablePortal
                              id="combo-box-demo"
                              options={societies}
                              // multiple
                              fullWidth
                              sx={{ m:0.5 }}
                              getOptionLabel={(option) => option.society}
                              isOptionEqualToValue={(option, value) => option.id === value.id}
                              onChange={(event, value) => {
                                handleDisplaySociety(value.id, value.society)
                              }}
                              renderInput={(params) => <TextField {...params} variant='standard' size="small" placeholder='Select Society'/>}
                            />
                            {
                              hold_name?
                              <Typography
                                sx={{ textAlign:'center', m:1 }}
                                fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif"
                              >
                                <b>Viewing {hold_name}</b>
                              </Typography>
                              :
                              <Typography
                                sx={{ textAlign:'center', m:1 }}
                                fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif"
                              >
                                <b>Choose Society Here 👆 </b>
                              </Typography>
                            }
                            
                          </Ittem>
                        </Grid>
                        
                        <Grid item xs={12} md={6}>
                          <Ittem>
                          <Typography
                            fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif"
                          >
                            <b>Switch Savings Account</b>
                          </Typography>

                          <Box sx={{ display:'flex', marginBottom:1, flexWrap:'wrap', maxWidth: '100%', overflowX: 'auto', '&::-webkit-scrollbar': {
                              height: '5px',
                            },
                            '&::-webkit-scrollbar-track': {
                                background: '#f1f1f1',
                            },
                            '&::-webkit-scrollbar-thumb': {
                                background: '#888',
                                borderRadius: '10px',
                            },
                            '&::-webkit-scrollbar-thumb:hover': {
                                background: '#555',
                          }}}>
                            <Chip
                                  label={
                                    <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                                      <b>All Accounts</b>
                                    </Typography>
                                  }
                                  size="small"
                                  variant={account_id == 0 ? "filled" : "outlined"}
                                  sx={{
                                    m: 1,
                                    boxShadow:
                                      "0 4px 8px rgba(0, 0, 0, 0.1), 0 8px 20px rgba(0, 0, 0, 0.1)",
                                    backgroundColor:
                                    account_id == 0 ? "#fff" : "#344e41",
                                    color: account_id == 0 ? "#000" : "#fff",
                                    "&:hover": {
                                      boxShadow:
                                        "0 8px 12px rgba(0, 0, 0, 0.2), 0 8px 30px rgba(0, 0, 0, 0.2)",
                                      backgroundColor: "#14213d",
                                      color: "#000",
                                    },
                                  }}
                                  onClick={() => account_switch(0)}
                                />
                            {
                              other_accounts && other_accounts?.map((account) => (
                                <Chip
                                  label={
                                    <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                                      <b>{account.account_name}</b>
                                    </Typography>
                                  }
                                  size="small"
                                  variant={account_id && account_id == account.id ? "filled" : "outlined"}
                                  sx={{
                                    m: 1,
                                    boxShadow:
                                      "0 4px 8px rgba(0, 0, 0, 0.1), 0 8px 20px rgba(0, 0, 0, 0.1)",
                                    backgroundColor:
                                    account_id && account_id == account.id ? "#fff" : "#344e41",
                                    color: account_id && account_id == account.id ? "#000" : "#fff",
                                    "&:hover": {
                                      boxShadow:
                                        "0 8px 12px rgba(0, 0, 0, 0.2), 0 8px 30px rgba(0, 0, 0, 0.2)",
                                      backgroundColor: "#14213d",
                                      color: "#000",
                                    },
                                  }}
                                  onClick={() => account_switch(account.id)}
                                />
                              ))
                            }
                          </Box>
                          </Ittem>
                        </Grid>
                        {society_dash}
                      </Grid>
                    </TabPanel>

                    <TabPanel value="2">
                      {/* Unions */}
                      <Grid container spacing={2}>
                        <Grid item xs={12} md={12}>
                          <Box
                            sx={{
                              display: "flex",
                              overflowX: "auto",
                              marginTop: "5px",
                              maxWidth: 1400,
                              "&::-webkit-scrollbar": {
                                height: "5px",
                              },
                              "&::-webkit-scrollbar-track": {
                                background: "#f1f1f1",
                              },
                              "&::-webkit-scrollbar-thumb": {
                                background: "#888",
                                borderRadius: "10px",
                              },
                              "&::-webkit-scrollbar-thumb:hover": {
                                background: "#555",
                              },
                            }}
                          >
                            {unions[0] ? (
                              <>
                                <Tooltip title="New Union">
                                  <IconButton
                                    onClick={() => handleOpenModal("Union")}
                                  >
                                    <AddCircleIcon sx={{ color: "2b2d42" }} />
                                  </IconButton>
                                </Tooltip>
                                {unions.map((item) => (
                                  <Tooltip
                                    title={
                                      <Grid container spacing={2}>
                                        <Grid item xs={12} md={12}>
                                          <Typography
                                            textAlign="center"
                                            fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif"
                                          >
                                            <b> Societies</b>
                                          </Typography>
                                          <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                                            <b>Update</b>
                                            <IconButton
                                              onClick={() =>
                                                handleEditModal(
                                                  item.id,
                                                  "Union"
                                                )
                                              }
                                            >
                                              <ViewAgendaIcon color="action" />
                                            </IconButton>
                                          </Typography>
                                        </Grid>
                                        {item.societies?.map((two) => (
                                          <Grid item xs={12} md={12}>
                                            <Typography
                                              textAlign="left"
                                              fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif"
                                            >
                                              <b>{two.society}</b>
                                            </Typography>
                                            <Divider variant="middle" />
                                          </Grid>
                                        ))}
                                      </Grid>
                                    }
                                  >
                                    <Chip
                                      key={item.id}
                                      size="small"
                                      label={
                                        <Typography
                                          variant="subtitle"
                                          fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif"
                                        >
                                          <b>{item.union_name}</b>
                                        </Typography>
                                      }
                                      sx={{
                                        borderRadius: 2,
                                        m: 1,
                                        boxShadow:
                                          "0 4px 8px rgba(0, 0, 0, 0.1), 0 8px 20px rgba(0, 0, 0, 0.1)",
                                        backgroundColor: "#2b2d42",
                                        color: "#fff",
                                        "&:hover": {
                                          boxShadow:
                                            "0 8px 12px rgba(0, 0, 0, 0.2), 0 8px 30px rgba(0, 0, 0, 0.2)",
                                          backgroundColor: "#14213d",
                                        },
                                      }}
                                      // onClick={() => handleDisplaySociety(item.id, item.society)}
                                    />
                                  </Tooltip>
                                ))}
                              </>
                            ) : (
                              <Typography
                                variant="subtitle"
                                fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif"
                              >
                                <b>Unions will appear here</b>
                                <Chip
                                  size="small"
                                  label={
                                    <Typography
                                      variant="subtitle"
                                      fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif"
                                    >
                                      <b>Build Union</b>
                                    </Typography>
                                  }
                                  sx={{
                                    borderRadius: 2,
                                    m: 1,
                                    boxShadow:
                                      "0 4px 8px rgba(0, 0, 0, 0.1), 0 8px 20px rgba(0, 0, 0, 0.1)",
                                    backgroundColor: "#2b2d42",
                                    color: "#fff",
                                    "&:hover": {
                                      boxShadow:
                                        "0 8px 12px rgba(0, 0, 0, 0.2), 0 8px 30px rgba(0, 0, 0, 0.2)",
                                      backgroundColor: "#14213d",
                                    },
                                  }}
                                  onClick={() => handleOpenModal("Union")}
                                />
                              </Typography>
                            )}
                          </Box>
                        </Grid>
                      </Grid>
                    </TabPanel>
                    <TabPanel value="3">
                      {/* Apexes */}
                      <Grid container spacing={2}>
                        <Grid item xs={12} md={12}>
                          <Box
                            sx={{
                              display: "flex",
                              overflowX: "auto",
                              marginTop: "5px",
                              maxWidth: 1400,
                              "&::-webkit-scrollbar": {
                                height: "5px",
                              },
                              "&::-webkit-scrollbar-track": {
                                background: "#f1f1f1",
                              },
                              "&::-webkit-scrollbar-thumb": {
                                background: "#888",
                                borderRadius: "10px",
                              },
                              "&::-webkit-scrollbar-thumb:hover": {
                                background: "#555",
                              },
                            }}
                          >
                            {apexes[0] ? (
                              <>
                                <Tooltip title="New Apex">
                                  <IconButton
                                    onClick={() => handleOpenModal("Apex")}
                                  >
                                    <AddCircleIcon sx={{ color: "2b2d42" }} />
                                  </IconButton>
                                </Tooltip>
                                {apexes.map((item) => (
                                  <Tooltip
                                    title={
                                      <Grid container spacing={2}>
                                        <Grid item xs={12} md={12}>
                                          <Typography
                                            textAlign="center"
                                            fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif"
                                          >
                                            <b>Unions</b>
                                          </Typography>
                                          <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                                            <b>Update</b>
                                            <IconButton
                                              onClick={() =>
                                                handleEditModal(item.id, "Apex")
                                              }
                                            >
                                              <ViewAgendaIcon color="action" />
                                            </IconButton>
                                          </Typography>
                                        </Grid>
                                        {item.unions?.map((two) => (
                                          <Grid item xs={12} md={12}>
                                            <Typography
                                              textAlign="left"
                                              fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif"
                                            >
                                              <b>{two.union_name}</b>
                                            </Typography>
                                            <Divider variant="middle" />
                                          </Grid>
                                        ))}
                                      </Grid>
                                    }
                                  >
                                    <Chip
                                      key={item.id}
                                      size="small"
                                      label={
                                        <Typography
                                          variant="subtitle"
                                          fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif"
                                        >
                                          <b>{item.apex_name}</b>
                                        </Typography>
                                      }
                                      sx={{
                                        borderRadius: 2,
                                        m: 1,
                                        boxShadow:
                                          "0 4px 8px rgba(0, 0, 0, 0.1), 0 8px 20px rgba(0, 0, 0, 0.1)",
                                        backgroundColor: "#2b2d42",
                                        color: "#fff",
                                        "&:hover": {
                                          boxShadow:
                                            "0 8px 12px rgba(0, 0, 0, 0.2), 0 8px 30px rgba(0, 0, 0, 0.2)",
                                          backgroundColor: "#14213d",
                                        },
                                      }}
                                      // onClick={() => handleDisplaySociety(item.id, item.apex_name)}
                                    />
                                  </Tooltip>
                                ))}
                              </>
                            ) : (
                              <Typography
                                variant="subtitle"
                                fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif"
                              >
                                <b>Apexes will appear here</b>
                                <Chip
                                  size="small"
                                  label={
                                    <Typography
                                      variant="subtitle"
                                      fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif"
                                    >
                                      <b>Build an Apex</b>
                                    </Typography>
                                  }
                                  sx={{
                                    borderRadius: 2,
                                    m: 1,
                                    boxShadow:
                                      "0 4px 8px rgba(0, 0, 0, 0.1), 0 8px 20px rgba(0, 0, 0, 0.1)",
                                    backgroundColor: "#2b2d42",
                                    color: "#fff",
                                    "&:hover": {
                                      boxShadow:
                                        "0 8px 12px rgba(0, 0, 0, 0.2), 0 8px 30px rgba(0, 0, 0, 0.2)",
                                      backgroundColor: "#14213d",
                                    },
                                  }}
                                  onClick={() => handleOpenModal("Apex")}
                                />
                              </Typography>
                            )}
                          </Box>
                        </Grid>
                      </Grid>
                    </TabPanel>
                  </Grid>
                </Grid>
              </TabContext>
            </Grid>
          </Grid>
        </Box>
      </main>
    </div>
  );
};
export default SavingsAccountPage;
